// Utils
import {
  findLandingPage,
  findCategoryLandingPage,
} from '../../modules/landingPage/landingPageUtils';

function generateDefaultInitialLandingPageState() {
  return {
    landingPageInfo: null,
    categoryLandingPageInfo: null,
  };
}

function landingPageReducer(state = generateDefaultInitialLandingPageState(), action) {
  let newState;

  switch (action.type) {
    case 'GET_LANDING_PAGE_INFO_FULFILLED': {
      const {triggerPayload} = action;
      const responseData = action.payload.response.data.data;

      newState = {
        ...state,
        landingPageInfo: findLandingPage(
          responseData,
          triggerPayload.id,
          triggerPayload.platform,
        )
      };
      break;
    }

    case 'GET_CATEGORY_LANDING_PAGE_INFO_FULFILLED': {
      const {triggerPayload} = action;
      const responseData = action.payload.response.data.data;

      newState = {
        ...state,
        categoryLandingPageInfo: findCategoryLandingPage(
          responseData,
          triggerPayload.categoryId,
          triggerPayload.platform,
        )
      };
      break;
    }

    case 'LEAVE_CATEGORY_PAGE_ROUTE':
    case 'LEAVE_DYNAMIC_PAGE_ROUTE':{
      newState = {
        ...state,
        landingPageInfo: null,
        categoryLandingPageInfo: null,
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default landingPageReducer;
export {generateDefaultInitialLandingPageState};
